module.exports = __webpack_public_path__ + "static/Apercu-Bold-3ce444d7ebe47d3697af3affcab49d1b.woff2";